module.exports = __webpack_public_path__ + "img/SER-A-1-III.eea5426b.png";